import { prop } from "lodash/fp";
import {
  getRecommendUserInfo,
  getActivityApplyConfig,
} from "../../axios/Activity/index";

const errorHint = () => {
  vue.$toast({
    message: "加载失败，请退出重试!",
    overlay: true,
    closeOnClickOverlay: true,
    duration: 10000
  });
};

export default {
  state: {
    adviser: {},
    config: {},
  },
  getters: {},
  mutations: {
    commitGuideInfo(state, data) {
      return (state.adviser = data);
    },
    commitConfig(state, data) {
      return (state.config = data);
    },
  },
  actions: {
    getRecommendUserInfo({ commit }, { meta }) {
      return getRecommendUserInfo(meta)
        .then((res) => {
          commit("commitGuideInfo", prop("data")(res));
          return res;
        });
    },
    getActivityApplyConfig({ commit }, { meta }) {
      return getActivityApplyConfig(meta)
        .then((res) => {
          commit("commitConfig", prop("data")(res));
          return res;
        })
        .catch((e) => {
          getActivityApplyConfig(meta)
            .then((res) => {
              commit("commitConfig", prop("data")(res));
              return res;
            })
            .catch((e) => {
              errorHint()
            });
        });
    },
  },
};
